<button pButton
        type="button"
        class="search-button"
        data-testid="search-btn"
        [disabled]="disabled"
        [attr.aria-label]="ariaLabel"
        (click)="handleClick($event)">
  <svg class="search-icon"
       width="30"
       height="22"
       viewBox="0 0 24 24"
       aria-hidden="true">
    <circle class="search-circle"
            cx="11"
            cy="11"
            r="6"></circle>
    <line class="search-line"
          x1="16"
          y1="16"
          x2="21"
          y2="21"></line>
  </svg>
</button>